import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import video from "./modules/video";
import asset from "./modules/asset";
import project from "./modules/project";
import pinwall from "./modules/pinwall";
import kaltura from "./modules/kaltura";
import user from "./modules/user";
import watcher from "./plugins/watch";
import mutationLogger from "./plugins/mutationLogger";

Vue.use(Vuex);

const state = {
  animationMode: false,
  player: null,
  selection: {},
  keyFrame: {
    selectedWaypoints: []
  },
  lastUsedColors: [],
  mode: "",
  notifications: [],
  configuration: {},
  grid: {
    active: false,
    size: 20
  },
  info: {
    key: null,
    props: {}
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    video,
    asset,
    user,
    project,
    pinwall,
    kaltura
  },
  plugins: [createPersistedState(), watcher, mutationLogger]
});
